import type { ProductCheckout } from '@entities/product/api/product.contract'

export type CheckoutSkin = 'new' | 'legacy'

type CheckoutStyle = Pick<ProductCheckout, 'template' | 'accent' | 'bannerUrl' | 'blocks' | 'fields'>

function checkoutStyleOf(checkout: ProductCheckout): CheckoutStyle {
  return {
    template: checkout.template,
    accent: checkout.accent,
    bannerUrl: checkout.bannerUrl,
    blocks: checkout.blocks,
    fields: checkout.fields,
  }
}

export function checkoutForSkin(checkout: ProductCheckout, skin: CheckoutSkin): ProductCheckout {
  if (skin === 'new' || !checkout.legacyPresentation) return checkout
  return { ...checkout, ...checkout.legacyPresentation }
}

export function applyCheckoutSkinPatch(
  checkout: ProductCheckout,
  skin: CheckoutSkin,
  input: Partial<ProductCheckout>,
): ProductCheckout {
  if (skin === 'new') return { ...checkout, ...input }

  const visual: Partial<CheckoutStyle> = {}
  if (input.template !== undefined) visual.template = input.template
  if (input.accent !== undefined) visual.accent = input.accent
  if (input.bannerUrl !== undefined) visual.bannerUrl = input.bannerUrl
  if (input.blocks !== undefined) visual.blocks = input.blocks
  if (input.fields !== undefined) visual.fields = input.fields

  const shared: Partial<ProductCheckout> = { ...input }
  delete shared.template
  delete shared.accent
  delete shared.bannerUrl
  delete shared.blocks
  delete shared.fields
  delete shared.legacyPresentation

  const next = { ...checkout, ...shared }
  if (Object.keys(visual).length === 0) return next
  return {
    ...next,
    legacyPresentation: {
      ...(checkout.legacyPresentation ?? checkoutStyleOf(checkout)),
      ...visual,
    },
  }
}
